import { RefObject } from 'react'

interface IOffset {
  x?: number
  y?: number
}

// Minimum distance the modal must be from the windwo edge to qualify for opening in that direction
const DECIDING_DISTANCE_FROM_EDGE = 100
// Distance this modal will always maintain from the edge
const DISTANCE_FROM_EDGE = 20

interface IModalAttributes {
  top?: number
  bottom?: number
  left?: number
  right?: number
  minWidth?: number
  maxWidth?: number
  minHeight?: number
  maxHeight?: number
}

/**
 *
 * @param target Target to place the modal next to
 * @param offset Minimum distance the modal needs to be placed away from the target
 */
const getModalPosition = (
  target: RefObject<any>,
  offset: IOffset = {}
): IModalAttributes => {
  const targetPosition = target.current.getBoundingClientRect()
  const modalPosition: IModalAttributes = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  }

  if (!offset.x) {
    offset.x = 0
  }

  if (!offset.y) {
    offset.y = 0
  }

  // First, decide which direction horizontally the modal will open
  if (window.innerWidth - targetPosition.right < DECIDING_DISTANCE_FROM_EDGE) {
    // If there is less than 100px from the end of the target to the end of the viewport horizontally
    // Open modal to the left
    modalPosition.right = window.innerWidth - targetPosition.right - offset.x
    modalPosition.left = undefined

    // Make sure the modal doesn't go out of window bounds
    modalPosition.maxWidth =
      window.innerWidth - modalPosition.right! - DISTANCE_FROM_EDGE // ! is fine because we just set it
  } else {
    // Open modal to the right
    modalPosition.left = targetPosition.left + offset.x
    modalPosition.right = undefined

    // Make sure the modal doesn't go out of window bounds
    modalPosition.maxWidth =
      window.innerWidth - modalPosition.left! - DISTANCE_FROM_EDGE // ! is fine because we just set it
  }

  // Then, decide which direction vertically the modal will open
  if (
    window.innerHeight - targetPosition.bottom <
    DECIDING_DISTANCE_FROM_EDGE
  ) {
    // If there is less than 100px from the end of the target to the end of the viewport vertically
    // Open modal upwards
    modalPosition.bottom =
      targetPosition.top - offset.y /* A small distance away from the target */
    modalPosition.top = DISTANCE_FROM_EDGE

    // Make sure the modal doesn't go out of window bounds
    modalPosition.maxHeight =
      window.innerHeight - modalPosition.bottom! - DISTANCE_FROM_EDGE // ! is fine because we just set it
  } else {
    // Open modal downwards
    modalPosition.top =
      targetPosition.bottom +
      offset.y /* A small distance away from the target */
    modalPosition.bottom = undefined

    // Make sure the modal doesn't go out of window bounds
    modalPosition.maxHeight =
      window.innerHeight - modalPosition.top! - DISTANCE_FROM_EDGE // ! is fine because we just set it
  }

  return modalPosition
}

export default getModalPosition
